import { Widget } from "./widget";

// tslint:disable-next-line:variable-name
export var W_BarChart = function (widgetInstance?) {
    widgetInstance = widgetInstance || {};

    var widget = new Widget(widgetInstance);
    $.extend(this, widget);

    var chartView = this.options.chartOption;

    this.theme = chartView.theme || "Flat";
    this.entityType = chartView.entityType || "";
    this.filter = chartView.filter;
    this.originalFilter = chartView.filter;
    this.filterDate = chartView.filterDate;
    this.filterId = chartView.filterId;
    this.groupBy = chartView.filter;
    this.expand = chartView.expand;
    this.select = chartView.select;
    this.xAxis = chartView.xAxis;
    this.yAxis = chartView.yAxis;
    this.searchOptions = chartView.searchOptions;
    this.dateInterval = chartView.dateInterval;
    this.dateIntervals = chartView.dateIntervals;
    this.chartType = chartView.chartType;
    this.toolTipTemplate = chartView.chartType;

    this.divisions = chartView.divisions === undefined
        ? true
        : chartView.divisions;

    this.regions = chartView.regions === undefined
        ? true
        : chartView.regions;

    this.hideSearchOptions = chartView.hideSearchOptions === undefined
        ? false
        : chartView.hideSearchOptions;

    this.autoBind = chartView.autoBind === undefined
        ? true
        : chartView.autoBind;

    this.liveFilter = chartView.liveFilter === undefined
        ? true
        : chartView.liveFilter;

    this.divisionAndRegionOnly = chartView.divisionAndRegionOnly === undefined
        ? false
        : chartView.divisionAndRegionOnly;

    this.init();
};
